import { Suspense, lazy } from 'react';
import { Building2, Loader2 } from 'lucide-react';
import ClonModuleButton from '../../components/ClonModuleButton';

const KundenStammPage = lazy(() => import('stammdaten/pages/KundenStammPage'));

function Fallback() {
  return (
    <div className="flex items-center justify-center py-20">
      <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
    </div>
  );
}

/**
 * Kunden-Uebersicht (Joerg 2026-05-30): eigenstaendige Page direkt auf
 * `/uebersicht/kunden`, NICHT als Sub-Tab im Adressbuch. Damit ist die
 * Kundenakte ohne Umweg ueber das Adressbuch erreichbar — Klick auf einen
 * Kunden in der Liste fuehrt direkt zu `/kunden/:id` (CustomerDetailPage
 * mit Tabs Stammdaten/Aufgaben/Berichte/Akte).
 *
 * Die fruehere Route (`/uebersicht/kunden` → Redirect auf Adressbuch) ist
 * damit ueberholt.
 */
interface Props {
  embedded?: boolean;
}

export default function UebersichtKunden({ embedded = false }: Props = {}) {
  return (
    <div>
      <div className="border-b border-default bg-card/30">
        <div className="max-w-7xl mx-auto px-4 h-11 flex items-center gap-2">
          <div className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-foreground">
            <Building2 size={14} />
            <span>Kunden</span>
          </div>
          {!embedded && (
            <div className="ml-auto">
              <ClonModuleButton widgetSlug="kunden.embed" defaultName="Meine Kunden" icon="Building2" />
            </div>
          )}
        </div>
      </div>
      <Suspense fallback={<Fallback />}>
        <KundenStammPage />
      </Suspense>
    </div>
  );
}
